import { apiRequest } from './api';
import type { Customer, CreateCustomerDto, UpdateCustomerDto, CustomerFilters } from '@/types';

export const customerService = {
  /**
   * Lista todos os customers do usuário
   */
  async listCustomers(filters: CustomerFilters = {}): Promise<Customer[]> {
    const params = new URLSearchParams();

    if (filters.page) params.append('page', filters.page.toString());
    if (filters.limit) params.append('limit', filters.limit.toString());
    if (filters.offset) params.append('offset', filters.offset.toString());

    const queryString = params.toString();
    const endpoint = queryString
      ? `/customer/customers?${queryString}`
      : '/customer/customers';

    return apiRequest<Customer[]>(endpoint);
  },

  /**
   * Busca um customer por ID
   */
  async getCustomerById(id: string): Promise<Customer> {
    return apiRequest<Customer>(`/customer/customers/${id}`);
  },

  /**
   * Busca um customer por CPF
   */
  async getCustomerByCpf(cpf: string): Promise<Customer> {
    // Remove formatação do CPF para a busca
    const cleanCpf = cpf.replace(/\D/g, '');
    return apiRequest<Customer>(`/customer/customers/cpf/${cleanCpf}`);
  },

  /**
   * Cria um novo customer
   */
  async createCustomer(data: CreateCustomerDto): Promise<Customer> {
    // Remove formatação do CPF e telefones
    const payload = {
      ...data,
      cpf: data.cpf.replace(/\D/g, ''),
      phone1: data.phone1.replace(/\D/g, ''),
      phone2: data.phone2 ? data.phone2.replace(/\D/g, '') : undefined,
    };

    return apiRequest<Customer>(
      '/customer/customers',
      {
        method: 'POST',
        body: JSON.stringify(payload),
      }
    );
  },

  /**
   * Atualiza um customer existente
   */
  async updateCustomer(id: string, data: UpdateCustomerDto): Promise<Customer> {
    // Remove formatação se CPF ou telefones forem fornecidos
    const payload: any = { ...data };
    if (payload.cpf) {
      payload.cpf = payload.cpf.replace(/\D/g, '');
    }
    if (payload.phone1) {
      payload.phone1 = payload.phone1.replace(/\D/g, '');
    }
    if (payload.phone2) {
      payload.phone2 = payload.phone2.replace(/\D/g, '');
    }

    return apiRequest<Customer>(
      `/customer/customers/${id}`,
      {
        method: 'PUT',
        body: JSON.stringify(payload),
      }
    );
  },

  /**
   * Deleta um customer
   */
  async deleteCustomer(id: string): Promise<void> {
    return apiRequest<void>(
      `/customer/customers/${id}`,
      {
        method: 'DELETE',
      }
    );
  },
};
